import { render } from "./TopNavBar.vue?vue&type=template&id=908a7c38&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=908a7c38&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908a7c38"]])

export default __exports__